import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import day from 'utils/day';
import { singleProvider } from '../mockData/provider-data';
import {
  providerAvailability,
  appointmentsAfter,
  appointmentsBefore,
  appType,
  appTypes,
  patientsAppointments,
  appointmentsData,
  appointmentData,
} from '../mockData/appointments-data';
import { singleOrganization } from '../mockData/organizations-data';

const AppointmentsApi = [
  rest.get(`${API_ROOT}appointments`, (req, res, ctx) => {
    const after = req.url.searchParams.get('after');
    const before = req.url.searchParams.get('before');
    const patientId = req.url.searchParams.get('patientId');
    const providerId = req.url.searchParams.get('providerId[]');

    const organizationId = req.url.searchParams.get('organizationId');

    if (after && before && patientId) {
      return res(ctx.json(patientsAppointments));
    }
    if (after) {
      return res(ctx.json(appointmentsAfter));
    }
    if (before) {
      return res(ctx.json(appointmentsBefore));
    }
    if (organizationId && providerId) {
      return res(ctx.json(appointmentsData));
    }
    if (providerId) {
      return res(ctx.json(appointmentsData));
    }
    return res(ctx.json([]));
  }),

  rest.get(`${API_ROOT}appointment-types`, (req, res, ctx) => {
    const providerId = req.url.searchParams.get('providerId');
    const organizationId = req.url.searchParams.get('organizationId');
    if (providerId && organizationId) {
      return res(ctx.json(appType));
    }
    return res(ctx.json({ data: [] }));
  }),

  rest.post(`${API_ROOT}appointments`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.put(`${API_ROOT}appointments/3660`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.get(`${API_ROOT}appointments/3660`, (req, res, ctx) => res(ctx.json(appointmentData))),
  rest.delete(`${API_ROOT}appointments/3660?reason=No+Show`, (req, res, ctx) => res(ctx.json({ success: true }))),

  rest.put(`${API_ROOT}providers/${singleProvider.rows[0].id}/availability`, (req, res, ctx) => {
    const appointmentType = req.url.searchParams.get('appointmentType');
    const month = req.url.searchParams.get('month');
    if (appointmentType === singleOrganization.defaultAppointmentId && month === day().format('YYYY-MM-DD')) {
      return res(ctx.json(providerAvailability));
    }
    return res(
      ctx.json({
        providerTimezone: '',
        selectedDate: '',
        data: [],
      }),
    );
  }),
  rest.get(`${API_ROOT}appointment-types`, (req, res, ctx) => {
    const providerId = req.url.searchParams.get('providerId');
    const isActive = req.url.searchParams.get('isActive');
    const organizationId = req.url.searchParams.get('organizationId');
    if (providerId && isActive && organizationId) {
      return res(ctx.json(appTypes));
    }
    return res(ctx.json({ data: [] }));
  }),
];
export default AppointmentsApi;
